module.exports = __webpack_public_path__ + "img/handraw_bulle d'aide bleu.f075db04.svg";